import differenceWith from 'lodash/differenceWith'
import includes from 'lodash/includes'
import qs from 'qs'

import { OrderStatus } from '__generated__/atlas-types'

import messages from './ChangeStatusModal.messages'

export enum OrderStatusValue {
  STATUS_PENDING = 3,
  STATUS_APPROVED = 4,
  STATUS_CANCELLED = 5,
  STATUS_SHIPPED = 7,
  STATUS_NOTES = 8,
}

export type LegacyOption = {
  value: number
  text: string
  code: string
}

export const getDropdownOptions = (isRetailer: boolean): LegacyOption[] =>
  isRetailer
    ? [
        {
          value: OrderStatusValue.STATUS_NOTES,
          text: messages.notes,
          code: OrderStatus.NOTES,
        },
        {
          value: OrderStatusValue.STATUS_PENDING,
          text: messages.pending,
          code: OrderStatus.PENDING,
        },
      ]
    : [
        {
          value: OrderStatusValue.STATUS_NOTES,
          text: messages.notes,
          code: OrderStatus.NOTES,
        },
        {
          value: OrderStatusValue.STATUS_PENDING,
          text: messages.pending,
          code: OrderStatus.PENDING,
        },
        {
          value: OrderStatusValue.STATUS_APPROVED,
          text: messages.approved,
          code: OrderStatus.APPROVED,
        },
        {
          value: OrderStatusValue.STATUS_SHIPPED,
          text: messages.shipped,
          code: OrderStatus.SHIPPED,
        },
        {
          value: OrderStatusValue.STATUS_CANCELLED,
          text: messages.cancelled,
          code: OrderStatus.CANCELLED,
        },
      ]

export const shouldCheckMinimums = (status: number | null) => {
  const statusWithValidation = [
    OrderStatusValue.STATUS_PENDING,
    OrderStatusValue.STATUS_APPROVED,
    OrderStatusValue.STATUS_SHIPPED,
  ]
  return includes(statusWithValidation, status)
}

export type ChangeStatusInputType = {
  validOrderIds: string[]
  status: number | null
  emailRetailer?: boolean
  emailBrand?: boolean
}

export const getPhpRequestData = ({
  validOrderIds,
  status,
  emailRetailer,
  emailBrand,
}: ChangeStatusInputType): string => {
  const data = validOrderIds.reduce(
    (acc, orderId) => {
      acc.Order[orderId] = {
        status: {
          value: status,
          options: {
            email: emailRetailer,
            dEmail: emailBrand, // d stands for designer (brand)
          },
        },
      }
      return acc
    },
    { Order: {} as Record<string, unknown> },
  )

  return qs.stringify(data)
}

export const restructureResponse = ({ data }: any, validOrderIds: string[]) => {
  const notUpdatedOrders = data.success
    ? []
    : data.statuses && data.statuses[0].object
  const updatedOrders = data.success
    ? validOrderIds
    : data.statuses &&
      differenceWith(
        validOrderIds,
        data.statuses[0].object,
        (val1, val2: string) => val1.toString() === val2.toString(),
      )
  return {
    updatedOrders: updatedOrders || [],
    notUpdatedOrders: notUpdatedOrders || [],
  }
}
